import angular from "angular";

angular
    .module('ui-common')
    .directive('cookielawStubScript', ['$rootScope', '$document', function($rootScope) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                const deregisterWatch = $rootScope.$watch('isOrsProd', function(newVal) {
                    if (!newVal) {
                        return;
                    }
                    element[0].type = 'text/javascript';
                    element[0].charset = 'UTF-8';
                    element[0].src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
                    deregisterWatch();
                });
            }
        };
    }]);
